import { Schema } from "effect";
export const DayOfWeek = Schema.Literal("sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday");
export const WorkingHours = Schema.Struct({
    // The days of the week on which the user works.
    daysOfWeek: Schema.Array(DayOfWeek),
    // The time of the day that the user starts working. Expected format: "HH:MM:SS.0000000"
    startTime: Schema.String,
    // The time of the day that the user stops working. Expected format: "HH:MM:SS.0000000"
    endTime: Schema.String,
});
export const TimeSlot = Schema.Struct({
    start: Schema.Date,
    end: Schema.Date,
});
export const PersonConfig = Schema.Struct({
    name: Schema.optional(Schema.String),
    email: Schema.optional(Schema.String),
    phoneNumber: Schema.optional(Schema.String),
    recordOptOut: Schema.optional(Schema.Boolean),
    recordOptIn: Schema.optional(Schema.Boolean),
});
export const MeetingTimes = Schema.Struct({
    timeSlots: Schema.Array(TimeSlot),
    interviewer: PersonConfig,
    interviewee: PersonConfig,
    disableRecordingOptions: Schema.Boolean,
    isGenericLink: Schema.Boolean,
    remainingReschedules: Schema.optional(Schema.Number),
    endDate: Schema.String,
    scheduledStartTime: Schema.optional(Schema.Date),
});
export const IntervieweeConfig = Schema.Struct({
    name: Schema.String,
    email: Schema.String,
    phoneCountry: Schema.String,
    phoneNumber: Schema.String,
    brand: Schema.String,
    smsOptIn: Schema.Boolean,
    smsOptOut: Schema.Boolean,
    recordOptIn: Schema.NullishOr(Schema.Boolean),
    recordOptOut: Schema.NullishOr(Schema.Boolean),
    locale: Schema.String,
});
export const SetMeetingTime = Schema.Struct({
    timeSlot: TimeSlot,
    localTimeZone: Schema.String,
    interviewee: IntervieweeConfig,
    reschedule: Schema.Boolean,
});
export const MeetNowRequest = Schema.Struct({
    interviewee: IntervieweeConfig,
    localTimeZone: Schema.NullishOr(Schema.String),
    startInMinutes: Schema.NullishOr(Schema.Number),
    duration: Schema.NullishOr(Schema.Number),
    bypassValidation: Schema.NullishOr(Schema.Boolean),
});
